export function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}



//////////////////
// WEBPACK FOOTER
// D:/Projects/MDA/schoolofmusic-ucla/web/app/themes/ucla/node_modules/moment/src/lib/locale/constructor.js
// module id = 64
// module chunks = 0